<template>
    <v-dialog v-model="showModal" max-width="400" max-height="300">
      <v-card>
        <v-card-title class="headline">Reset Pin Modal</v-card-title>
        <v-card-text>
          You need to reset your pin.
        </v-card-text>
        <v-card-actions>
          <v-btn @click="goToChangePin">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    props: {
      showModal: Boolean
    },
    methods: {
      goToChangePin() {
        this.$router.push('/settings/change-pin')
      }
    }
  }
  </script>
  